<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
    >
      <el-form-item class="r-20" prop="username">
        <el-input v-model="queryForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>

      <el-button size="medium" v-if="hasPerm('sys:log:list')" type="primary" @click="query">查询</el-button>
      <el-button size="medium" v-if="hasPerm('sys:log:list')" @click="reset">取消</el-button>
    </el-form>
    <el-table
      ref="logTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      stripe
      size="mini"
      height="560px"
    >
      <el-table-column type="index" align="center" label="序号" width="55"></el-table-column>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="operation" label="用户操作"></el-table-column>
      <el-table-column prop="method" label="请求方法" show-overflow-tooltip></el-table-column>
      <el-table-column prop="params" label="请求参数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="time" label="执行时长（毫秒）"></el-table-column>
      <el-table-column prop="ip" label="IP地址"></el-table-column>
      <el-table-column prop="addTime" label="创建时间" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
      queryForm: {
        username: ''
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: []
    }
  },
  created () {
    this.getLogList()
  },
  methods: {
    query () {
      this.getLogList()
    },
    reset () {
      this.$resetForm(this, 'queryForm')
      this.getLogList()
    },
    async getLogList () {
      let parm = {}
      parm.username = this.queryForm.username
      parm.limit = this.limit;
      parm.page = this.currentPage;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/log/list",
        { params: parm }
      )
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getLogList()
    },
    handleSizeChange (val) {
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.con-wrap {
  background-color: #fff;
  padding: 0 20px;
}
</style>